import { Card, CardContent, CardHeader, Separator, Skeleton } from 'design-system';

export const MarketWidgetSkeleton = () => (
  <Card
    className='min-h-[280px] w-full gap-0 overflow-hidden py-0'
    data-testid='market-widget-skeleton'
  >
    <CardHeader
      className='shrink-0 gap-3 px-6 py-4'
      data-testid='market-widget-header-skeleton'
    >
      <div className='flex min-w-0 flex-1 items-center gap-4'>
        <Skeleton className='h-5 w-28' />
        <Skeleton className='h-5 w-20' />
      </div>
      <Skeleton className='size-8 rounded-md' />
    </CardHeader>
    <Separator />
    <CardContent
      className='flex min-h-0 flex-1 flex-col gap-4 p-6'
      data-testid='market-widget-content-skeleton'
    >
      <Skeleton className='h-4 w-full' />
      <Skeleton className='h-4 w-4/5' />
      <Skeleton className='mt-2 h-8 w-3/5' />
      <Skeleton className='h-4 w-2/5' />
    </CardContent>
  </Card>
);
